<div class="container-fluid wrapper-page">
  <div class="page-head">
    <div class="row">
      <div class="col-12">
        <h5 class="header-title heading-color">APPOINTMENTS TO CHECK-IN</h5>
      </div>
      <div class="col-lg-12">
        <div class="card m-b-30">
          <form #checkinForm="ngForm">
            <div class="card-body">
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-4 margin-bottom">
                      <ng-template #rt let-r="result" let-t="term">
                        {{ r.pat_name }}
                      </ng-template>
                      <input type="text" class="form-control" placeholder="Patient name" aria-label="Search"
                        name="model" [(ngModel)]="model" />
                    </div>

                    <div class="col-md-4 margin-bottom">
                      <ng-template #rt let-r="result" let-t="term">
                        {{ r.doc_name }}
                      </ng-template>
                      <input type="text" class="form-control" placeholder="Physician name" aria-label="Search"
                        name="model2" [(ngModel)]="model2" />
                    </div>


                    <div class="input-group margin-bottom col-md-4 m-t-10">
                      <input name="chkdob" class="form-control" placeholder="AP Date (DD/MM/YYYY)" [(ngModel)]="chkdob"
                        ngbDatepicker #d="ngbDatepicker" data-date-inline-picker="false" />
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar rounded-0" (click)="d.toggle()" type="button"
                          style="line-height: 2.5;">
                          <span class="fa fa-calendar"></span>
                        </button>
                      </div>
                      <div *ngIf="isError" class="invalid-feedback">
                        Invalid date
                      </div>
                    </div>

                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-5 center-mobile">
                      <button type="submit" (click)="displaycheckin(checkinForm.value)"
                        class="btn btn-mobile btn-primary">
                        FIND APPOINTMENTS
                      </button>
                    </div>
                    <div class="col-md-3"></div>
                  </div>
                </div>
                <div class="col-md-4"></div>
              </div>
            </div>
          </form>
          <div *ngIf="isCheckInLoading">
            <appLoader [size]="small" [display]="isCheckInLoading" [screen]="container" style="z-index: 1000;">
            </appLoader>
          </div>
        </div>
      </div>
    </div>
    <!--END ROW-->

    <div id="appdesktop" *ngIf="acheckin">
      <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card m-b-30">
            <div class="card-body table-responsive">
              <div class="row">
                <div align="center" class="col-lg-12">
                  <h4 class="header-title heading-color ">
                    SCHEDULED APPOINTMENTS
                  </h4>
                </div>
              </div>
              <br />
              <!-- Display the ALL, Inperideo Consultations (NEED FOR NEXT DEVELOPMENT) -->
              <div class="row">
                <div class="col-lg-12">
                  <button type="submit" name="find"
                    class="btn btn-rounded button-color text-white button-padding mr-4 mt-md-1 mt-2"
                    [ngClass]="{ 'btn-primary': activeBtn != 'INPERSON' && activeBtn != 'ONLINE'  }"
                    (click)="displaycheckin(online_checkin='')">
                    ALL
                  </button>
                  <button type="submit" name="find"
                    class="btn btn-rounded text-white btn-rounded button-color pl-4 pr-4 mr-4 mt-md-1 mt-2"
                    [ngClass]="{ 'btn-primary': activeBtn === 'INPERSON' }"
                    (click)="displaycheckin(online_checkin='INPERSON')">
                    <img src="/assets/images/person.png" class="mr-2" />INPERSON
                  </button>
                  <button type="submit" name="find"
                    class="btn btn-rounded text-white btn-rounded button-color pl-4 pr-4 mr-4 mt-md-1 mt-2"
                    [ngClass]="{ 'btn-primary': activeBtn === 'ONLINE' }"
                    (click)="displaycheckin(online_checkin='ONLINE')">
                    <img src="/assets/images/computer.svg" class="mr-2" />INPERSON-ONLINE
                  </button>
                </div>
              </div>


              <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <div class="row">
                  <div class="col-md-12 mt-3 ">
                    <table id="datatable2" class="table dataTable no-footer" role="grid"
                      aria-describedby="datatable2_info">
                      <thead align="center">
                        <tr role="row">
                          <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-sort="ascending" aria-label="Name: activate to sort column descending"
                            style="width: 15%;">
                            AP DATE
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Position: activate to sort column ascending" style="width: 15%;">
                            AP TIME
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Office: activate to sort column ascending" style="width: 15%;">
                            PATIENT
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Age: activate to sort column ascending" style="width: 15%;">
                            DOB
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Start date: activate to sort column ascending" style="width: 25%;">
                            CONSULTING DOCTOR
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Start date: activate to sort column ascending" style="width: 15%;">
                            CHECK IN
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr align="center" *ngFor="let item of acheckin; let i = index"
                          [ngClass]="{'odd-row': i % 2 !== 0, 'even-row': i % 2 === 0}">
                          <!-- <td>{{ item["online_checkin"] }}</td> -->
                          <td>{{ item["apdate"] | date: dateFormat }}</td>
                          <td>{{ formatTime(item.aptime) }}</td>
                          <!-- changes for displaying patients with null DOB-->
                          <!--<td>
                            {{ item["patient_first_name"] }} &nbsp;{{
                            item["patient_last_name"]
                            }}
                          </td>-->
                          <td>
                            {{ (item["patient_first_name"] === null && item["patient_last_name"] === null)? "Not
                            Available":item["patient_first_name"]+" "+item["patient_last_name"]}}
                          </td>
                          <!--<td>{{ item["dob"]  | date: dateFormat  }}</td>-->
                          <td>{{ item["dob"] === null? "Not Available":(item["dob"] | date: dateFormat )}}</td>
                          <td>
                            Dr.&nbsp;{{ item["physician_first_name"] }} &nbsp;
                            {{ item["physician_last_name"] }}
                          </td>
                          <td style="white-space: nowrap; width: 15%;">

                            <div *ngIf="item.chkstatus == 'Pending'" class="container">
                              <button type="button" class="tabledit-edit-button btn btn-sm btn-info"
                                style="float: none; margin: 5px;"
                                [routerLink]="['/appointments/Checkin/edit/' + item.aid]">
                                <span class="ti-pencil"></span>
                              </button>
                              <button *ngIf="item.currentDate" type="button"
                                class="tabledit-delete-button btn btn-sm btn-primary" style="float: none; margin: 5px;"
                                [routerLink]="[
                                      '/appointments/Checkin/Detail/' + item.aid
                                    ]">
                                Check In
                              </button>

                              <div *ngIf="!item.currentDate">Please Reschedule</div>
                            </div>

                            <!-- <div *ngIf="item.chkstatus == 'Pending'">
                              <div class="tabledit-toolbar btn-toolbar" style="text-align: left;">
                                <div class="btn-group btn-group-sm" style="float: none;">
                                  <button type="button" class="tabledit-edit-button btn btn-sm btn-info"
                                    style="float: none; margin: 5px;" [routerLink]="[
                                      '/appointments/Checkin/edit/' + item.aid
                                    ]">
                                    <span class="ti-pencil"></span>
                                  </button>
                                  <button type="button" class="tabledit-delete-button btn btn-sm btn-primary" 
                                    style="float: none; margin: 5px;" [routerLink]="[
                                      '/appointments/Checkin/Detail/' + item.aid
                                    ]">
                                    Check In
                                  </button>
                                </div>
                              </div>
                            </div> -->
                            <div *ngIf="item.chkstatus != 'Pending'">

                              {{ item.chkstatus }}

                            </div>
                          </td>
                          <td>

                          </td>
                        </tr>

                      </tbody>

                    </table>
                    <div [innerHTML]="innerHtml">
                    </div>

                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- /appdesktop -->

    <div id="appmobile">
      <div class="col-sm-12">
        <h5 class="header-title heading-color center-mobile">SCHEDULED APPOINTMENTS</h5>
      </div>
      <div [innerHTML]="innerHtml"></div>
      <div class="row" *ngFor="let item of acheckin; let i = index">

        <div class="col-12 col-sm-12">

          <div class="mcard">

            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">AP DATE</span>
              </div>
              <div class="cardcol">
                <span class="textblack">{{ item["apdate"] | date: "dd-MM-yyyy" }}
                </span>
              </div>
            </div>
            <!-- /cardrow -->
            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">AP TIME</span>
              </div>
              <div class="cardcol">
                <span class="textblack">{{ formatTime(item["aptime"]) }}

                </span>
              </div>
            </div>
            <!-- /cardrow -->


            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">PATIENT</span>
              </div>
              <div class="cardcol">
                <!--<span class="textblack">{{ item["patient_first_name"] }}
                  &nbsp;{{ item["patient_last_name"] }}
                </span>-->
                <span class="textblack">
                  {{ (item["patient_first_name"] === null && item["patient_last_name"] === null)? "Not
                  Available":item["patient_first_name"]+" "+item["patient_last_name"]}}
                </span>
              </div>
            </div>
            <!-- /cardrow -->
            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">DOB</span>
              </div>
              <div class="cardcol">
                <!--<span class="textblack">{{
                  item["dob"] | date: "dd-MMM-yyyy"
                  }}</span>-->
                <span class="textblack">{{ item["dob"] === null? "Not Available":(item["dob"] | date:
                  "dd-MMM-yyyy")}}</span>
              </div>
            </div>
            <!-- /cardrow -->
            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">CONSULTING DOCTOR</span>
              </div>
              <div class="cardcol">
                <span class="textblack text-capitalize">{{ item["physician_title"] ? item["physician_title"] :
                  defaultDr}}
                  &nbsp; {{ item["physician_first_name"] }}
                  &nbsp; {{ item["physician_last_name"] }}
                </span>
              </div>
            </div>
            <!-- /cardrow -->
            <div class="cardrow" *ngIf="item.chkstatus == 'Pending'">
              <div class="btn-group btn-group-sm actionbtm">
                <button type="button" class="tabledit-edit-button btn btn-sm btn-info" style="float: none; margin: 5px;"
                  [routerLink]="['/appointments/Checkin/edit/' + item.aid]">
                  <span class="ti-pencil"></span>
                </button>
                <button type="button" class="tabledit-delete-button btn btn-sm btn-primary"
                  style="float: none; margin: 5px;" [routerLink]="['/appointments/Checkin/Detail/' + item.aid]">
                  <!-- <span class="ti-trash"></span> -->
                  Check In
                </button>
              </div>
            </div><br>
            <!-- /cardrow -->
            <div class="center-mobile" *ngIf="item.chkstatus !== 'Pending'">
              <h5 align="center">
                <button class="btn-sm btn-success" style="float: none; margin: 5px;">
                  {{ item.chkstatus }}
                </button>

              </h5>
            </div>
          </div>


        </div>
        <!-- /col -->
        <div [innerHTML]="innerHtml">
        </div>
      </div>
      <!-- /row -->
    </div>
    <!-- /appmobile -->
  </div>
</div>
<!--end container-->